import * as React from 'react';
import {CustomerBlackList} from "../../../../../domain/model/customer_black_list";
import styled from "styled-components";
import ButtonDeletePermanentLink from "../../../../common/atom/button_delete_permanent_link";
import Paragraph from "../../../../common/atom/text/paragraph";

interface IProps {
    customerBlackList: CustomerBlackList | null;
    handleDeleteCustomerBlackListSubmit: (event: React.MouseEvent<HTMLButtonElement>) => void
}

const CustomerBlackListDeleteForm: React.FC<IProps> = (props) => {
    const {customerBlackList, handleDeleteCustomerBlackListSubmit } = props;

    if(customerBlackList === null) {
        return null
    }

    const domains: string[] = customerBlackList.domains;

    return(
        <form>

            <Paragraph bold={true}>ブロック済み企業ドメイン</Paragraph>
            <Ul>
                {domains.map((domain: string, index: number) => {
                    return (
                        <Li key={index}>
                            <ButtonDeletePermanentLink handleDeleteCustomerBlackListSubmit={handleDeleteCustomerBlackListSubmit} domain={domain} deleteValue={index}/>
                        </Li>
                    )
                })}
            </Ul>
        </form>
    )
};

export default CustomerBlackListDeleteForm;

const Ul = styled.ul`
    padding: 0;
    list-style: none;
   
`;

const Li = styled.li`
    margin: 20px 0;
`;



// WEBPACK FOOTER //
// ./src/presentation/component/customer/black_list/edit/client_black_list_delete_form.tsx